var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-tel-input',{attrs:{"value":_vm.value,"mode":"international","defaultCountry":"dk","autoDefaultCountry":false,"validCharactersOnly":true,"preferredCountries":['dk'],"inputOptions":{ name: _vm.name, placeholder: _vm.placeholder, required: _vm.required }},on:{"input":v => _vm.$emit('input', v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }